import { defineTemplate } from '../../../utils';
import { BRANDS } from '../_shared/data/brands';
import { PAYMENT_METHOD_HIGHLIGHT_VARIANTS } from '../_shared/pills/payment-method-highlight-variants';
import { CATEGORY_OPTIONS } from '../_shared/data/category-options';
import { PAYMENT_METHOD_TEXT_OPTIONS } from '../_shared/data/payment-method-options';
import { LEGALES_OPTIONS } from '../_shared/data/legales-options';
import { MACRO_MEDIA_BASE } from '../_shared/data/media';
import { WALLETS_OPTIONS } from '../_shared/data/wallets-options';
import { macroBeneficios1080x1920A } from './layouts/Beneficios-1080x1920-A';
import { macroBeneficios1080x1920B } from './layouts/Beneficios-1080x1920-B';
import { macroBeneficios1080x1920C } from './layouts/Beneficios-1080x1920-C';

const THUMB = `${MACRO_MEDIA_BASE}/templates/macro-beneficios/thumbnails/macro-beneficios.png`;

export const macroBeneficios = defineTemplate({
  mode: 'wysiwyg',
  id: 'macro-beneficios',
  clientId: 'MACRO',
  handlerKey: 'MACRO',
  title: 'Beneficios',
  thumbnail: { url: THUMB, optimizedUrl: THUMB, aspectRatio: 'vertical' },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'category',
      label: 'Categoría',
      type: 'select',
      required: true,
      defaultValue: 'GASTRONOMÍA',
      placeholder: 'Selecciona una categoría',
      options: CATEGORY_OPTIONS
    },
    {
      key: 'valid-days',
      label: 'Días de validez',
      type: 'input',
      placeholder: 'Ejemplo: Lunes a viernes',
      required: true,
      defaultValue: 'Lunes a viernes'
    },
    {
      key: 'discount-value',
      label: 'Texto del descuento',
      type: 'number',
      placeholder: 'Ejemplo: 20%',
      required: true,
      defaultValue: 20
    },
    {
      key: 'benefit-label',
      label: 'Beneficio',
      type: 'input',
      placeholder: 'de descuento, de 2x1, etc.',
      required: true,
      defaultValue: 'de ahorro'
    },
    {
      key: 'payment-method-text',
      label: 'Mensaje principal',
      type: 'input',
      placeholder: 'Con todas tus Tarjetas de Crédito Macro',
      required: true,
      defaultValue: 'Con todas tus Tarjetas de Crédito Macro',
      options: PAYMENT_METHOD_TEXT_OPTIONS
    },
    {
      key: 'payment-method-highlight',
      label: 'Mensaje adicional',
      type: 'polymorphic',
      required: false,
      defaultVariant: 'text',
      applicableResolutions: ['1080x1920-A', '1080x1920-B'],
      variants: [
        {
          key: 'text',
          label: 'Texto libre',
          fields: [
            {
              key: 'value',
              label: 'Mensaje',
              type: 'input',
              placeholder: 'Pagando con tu celular sin contacto',
              required: true,
              defaultValue: 'Pagando con tu celular sin contacto'
            }
          ]
        },
        {
          key: 'pill-pair',
          label: 'Doble pill',
          fields: [
            {
              key: 'left',
              label: 'Pill izquierda',
              type: 'input',
              placeholder: 'Exclusivo con',
              required: true,
              defaultValue: 'Exclusivo con'
            },
            {
              key: 'right',
              label: 'Pill derecha',
              type: 'input',
              placeholder: 'desde App',
              required: true,
              defaultValue: 'desde App'
            }
          ]
        },
        {
          key: 'pill-pair-inv',
          label: 'Doble pill (invertida)',
          fields: [
            {
              key: 'left-inv',
              label: 'Pill izquierda',
              type: 'input',
              placeholder: 'Pagá con',
              required: true,
              defaultValue: 'Pagá con'
            },
            {
              key: 'right-inv',
              label: 'Pill derecha',
              type: 'input',
              placeholder: 'desde App',
              required: true,
              defaultValue: 'desde App'
            }
          ]
        }
      ]
    },
    {
      key: 'payment-method-highlight-C',
      label: 'Mensaje adicional',
      type: 'input',
      placeholder: 'Pagando exclusivo con MODO desde la app',
      required: true,
      defaultValue: 'Pagando exclusivo con MODO desde la app',
      applicableResolutions: ['1080x1920-C']
    },
    {
      key: 'wallets-enabled',
      label: 'Billeteras digitales',
      type: 'image-multi-select',
      required: true,
      defaultValue: [],
      applicableResolutions: ['1080x1920-A', '1080x1920-B'],
      options: WALLETS_OPTIONS
    },
    {
      key: 'limit-text',
      label: 'Texto del tope',
      type: 'input',
      multiline: true,
      placeholder: 'Ejemplo: Hasta agotar stock',
      required: true,
      defaultValue: 'Tope $10.000 por cliente, por semana.'
    },
    {
      key: 'legales',
      label: 'Legales',
      type: 'input',
      placeholder: 'CARTERA CONSUMO',
      required: false,
      options: LEGALES_OPTIONS
    },
    {
      key: 'brand-logo',
      label: 'Logo de la marca',
      type: 'visual-search-single',
      required: false,
      allowCustomInput: true,
      tooltip: 'Subí el logo de la marca. PNG transparente recomendado.',
      options: BRANDS.map(b => ({
        value: b.imageUrl,
        label: b.label,
        imageUrl: b.imageUrl
      }))
    },
    {
      key: 'background-image',
      label: 'Imagen de fondo',
      type: 'image',
      required: false
    },
    {
      key: 'installments-value',
      label: 'Cantidad de cuotas',
      type: 'number',
      placeholder: 'Ejemplo: 6',
      required: false,
      defaultValue: 6,
      applicableResolutions: ['1080x1920-A', '1080x1920-C']
    },
    {
      key: 'discount-value-selecta',
      label: 'Descuento clientes Selecta',
      type: 'number',
      placeholder: 'Ejemplo: 30%',
      required: true,
      defaultValue: 30,
      applicableResolutions: ['1080x1920-C']
    }
  ],
  canvasBinding: {
    resolutions: [
      {
        id: '1080x1920-A',
        label: '1080×1920 A',
        canvasWidth: 1080,
        canvasHeight: 1920,
        type: 'image',
        layout: macroBeneficios1080x1920A
      },
      {
        id: '1080x1920-B',
        label: '1080×1920 B',
        canvasWidth: 1080,
        canvasHeight: 1920,
        type: 'image',
        layout: macroBeneficios1080x1920B
      },
      {
        id: '1080x1920-C',
        label: '1080×1920 C',
        canvasWidth: 1080,
        canvasHeight: 1920,
        type: 'image',
        layout: macroBeneficios1080x1920C
      }
    ],
    fieldBindings: [
      { kind: 'simple', fieldKey: 'category', pieceId: 'category', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'valid-days', pieceId: 'valid-days', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'discount-value', pieceId: 'discount-value', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'benefit-label', pieceId: 'benefit-label', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'payment-method-text', pieceId: 'payment-method-text', bindingType: 'text' },
      {
        kind: 'polymorphic',
        fieldKey: 'payment-method-highlight',
        defaultVariant: 'text',
        applicableResolutions: ['1080x1920-A', '1080x1920-B'],
        variants: PAYMENT_METHOD_HIGHLIGHT_VARIANTS,
        positionsByResolution: {
          '1080x1920-B': {
            'payment-method-highlight-text': { top: 1145.7627 },
            'payment-method-highlight-pair': { top: 1145.7627 },
            'payment-method-highlight-pair-inv': { top: 1145.7627 }
          }
        }
      },
      { kind: 'simple', fieldKey: 'wallets-enabled', pieceId: 'wallets', bindingType: 'group-collection' },
      { kind: 'simple', fieldKey: 'limit-text', pieceId: 'limit-text', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'legales', pieceId: 'legales', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'brand-logo', pieceId: 'brand-logo', bindingType: 'image-replace' },
      { kind: 'simple', fieldKey: 'background-image', pieceId: 'background-image', bindingType: 'image-replace' },
      { kind: 'simple', fieldKey: 'installments-value', pieceId: 'installments-value', bindingType: 'text' },
      {
        kind: 'simple',
        fieldKey: 'discount-value-selecta',
        pieceId: 'discount-value-selecta',
        bindingType: 'text'
      },
      {
        kind: 'simple',
        fieldKey: 'payment-method-highlight-C',
        pieceId: 'payment-method-highlight-C',
        bindingType: 'text'
      }
    ]
  }
});
